import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import useUnarchiveVault from '@/services/api/vault/useUnarchiveVault'
import {
  ArrowPathRoundedSquareIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid'
import React, { useState } from 'react'

interface UnArchiveVaultProps {
  id: number
}

export default function UnArchiveVault({ id }: UnArchiveVaultProps) {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const { mutate: unarchiveVault } = useUnarchiveVault()

  function unArchive() {
    unarchiveVault(id)
    setShowConfirmation(false)
  }

  return (
    <>
      <Dialog open={showConfirmation} onOpenChange={setShowConfirmation}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Unarchive Vault</DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>

          <DialogBody>
            <p>
              Are you sure you want to unarchive this vault? Once unarchived, it
              will be available for selection in transactions again.
            </p>
          </DialogBody>

          <DialogFooter>
            <Button type="button" variant="destructive" onClick={unArchive}>
              Unarchive
            </Button>

            <DialogClose asChild>
              <Button type="button" variant="secondary">
                Cancel
              </Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              iconOnly
              variant="ghost"
              onClick={() => setShowConfirmation(true)}
            >
              <ArrowPathRoundedSquareIcon />
            </Button>
          </TooltipTrigger>
          <TooltipPortal>
            <TooltipContent align="end">
              Restore
              <TooltipArrow />
            </TooltipContent>
          </TooltipPortal>
        </Tooltip>
      </TooltipProvider>
    </>
  )
}
